<template>
    <div class="loader-container" :style="{ backgroundColor: background ? '#00000052' : 'none', position: background ? 'fixed' : 'absolute', display: loading ? 'flex' : 'none' }">
        <div class="loader-box" :style="{ backgroundColor: bgColor, boxShadow: background ? '3px 3px 10px #00000064': 'none' }"">
            <div class="loader"></div>
            <span>{{ loadingText }}</span>
        </div>
    </div>
  </template>
  
  <script>
  
  export default {
    props:{
        loading: {
            type: Boolean,
            default: false,
        },
        background: {
            type: Boolean,
            default: false,
        },
        loadingText: {
            type: String,
            default: 'Carregando...',
        },
    },
    data() {
      return {
      };
    },
    computed:{
        bgColor(){
            if(this.background) return '#FFFFFF';
            else return 'transparent';
        },
    },
    watch: {
        loading: function(newVal) {
            document.body.classList.toggle('noscroll', newVal);
        },
    },
    mounted(){
        if(this.background) document.body.classList.toggle('noscroll', true);
    },
  };
  </script>
  
  <style scoped>
    .loader-container {
        align-items: center;
        display: flex;
        justify-content: center;
        position:absolute;
        height:100%;
        width:100%;
        z-index:100001;
    }
    .loader-box{
        display:flex;
        justify-content:center;
        align-items:center;
        flex-flow:column;
        padding: 40px 20px;
        border-radius:5px;
    }
    span{font: normal normal bold 15px/20px 'Kanit', sans-serif !important; letter-spacing:0;color:#597EB5; animation: pulseFade 7s infinite;}
    .loader  {
        animation: rotate 1.8s infinite;  
        height: 50px;
        width: 50px;
        margin-bottom:10px;
    }

    .loader:before,
    .loader:after {   
        border-radius: 50%;
        content: '';
        display: block;
        height: 20px;  
        width: 20px;
    }
    .loader:before {
        animation: ball1 1.8s infinite;  
        background-color: #4780f1;
        box-shadow: 30px 0 0 #1aceb5;
        margin-bottom: 10px;
    }
    .loader:after {
        animation: ball2 1.8s infinite; 
        background-color: #16b0d2;
        box-shadow: 30px 0 0 #3791e7;
    }

    @keyframes pulseFade {
        20% { opacity: 1; }
        30% { opacity: 0; }
        40% { opacity: 1; }
        60% { opacity: 1; }
        70% { opacity: 0; }
        90% { opacity: 1; }
    }
    
    @keyframes rotate {
        0% { 
            -webkit-transform: rotate(0deg) scale(0.8); 
            -moz-transform: rotate(0deg) scale(0.8);
        }
        50% { 
            -webkit-transform: rotate(360deg) scale(1.2); 
            -moz-transform: rotate(360deg) scale(1.2);
        }
        100% { 
            -webkit-transform: rotate(720deg) scale(0.8); 
            -moz-transform: rotate(720deg) scale(0.8);
        }
    }

    @keyframes ball1 {
        0% {
            box-shadow: 30px 0 0 #1aceb5;
        }
        50% {
            box-shadow: 0 0 0 #1aceb5;
            margin-bottom: 0;
            -webkit-transform: translate(15px,15px);
            -moz-transform: translate(15px, 15px);
        }
        100% {
            box-shadow: 30px 0 0 #1aceb5;
            margin-bottom: 10px;
        }
    }

    @keyframes ball2 {
        0% {
            box-shadow: 30px 0 0 #3791e7;
        }
        50% {
            box-shadow: 0 0 0 #3791e7;
            margin-top: -20px;
            -webkit-transform: translate(15px,15px);
            -moz-transform: translate(15px, 15px);
        }
        100% {
            box-shadow: 30px 0 0 #3791e7;
            margin-top: 0;
        }
    }
  </style>
  